import {
    DEVICE_MOBILE_IOS, DEVICE_MOBILE_ANDROID, DEVICE_MOBILE_OTHER,
    DEVICE_TABLET_IOS, DEVICE_TABLET_OTHER,
    DEVICE_DESKTOP_MAC, DEVICE_DESKTOP_WINDOWS, DEVICE_DESKTOP_OTHER
} from '~/common/utils/consts.js';

// returns string with information about the device being used
export default function deviceDetection() {
    // pulls ugent user
    const deviceAgent = navigator.userAgent.toLowerCase();

    if (deviceAgent.match(/(iphone|ipod)/)) {
        return DEVICE_MOBILE_IOS;
    }
    if (deviceAgent.match(/android/)) {
        return DEVICE_MOBILE_ANDROID;
    }
    if (deviceAgent.match(/(blackberry|symbianos|^sonyericsson|^nokia|^samsung|^lg)/)) {
        return DEVICE_MOBILE_OTHER;
    }
    if (deviceAgent.match(/ipad/)) {
        return DEVICE_TABLET_IOS;
    }
    if (deviceAgent.match(/tablet/)) {
        return DEVICE_TABLET_OTHER;
    }
    if (deviceAgent.match(/mac/) && !deviceAgent.match(/(iphone|ipod|ipad)/)) {
        return DEVICE_DESKTOP_MAC;
    }
    if (deviceAgent.match(/windows/)) {
        return DEVICE_DESKTOP_WINDOWS;
    }
    return DEVICE_DESKTOP_OTHER;
}

export function isIOSDevice() {
    return [
        DEVICE_MOBILE_IOS,
        DEVICE_TABLET_IOS
    ].includes(deviceDetection());
}

export function isTouchDevice() {
    return [
        DEVICE_MOBILE_IOS,
        DEVICE_MOBILE_ANDROID,
        DEVICE_MOBILE_OTHER,
        DEVICE_TABLET_IOS,
        DEVICE_TABLET_OTHER
    ].includes(deviceDetection());
}
